/**
 * 自治体・エリア関連
 */
define(function () {
    /**
     * 指定されたコードが都道府県の自治体コードであるかどうかを返す
     */
    function _isPrefecture(code) {
        // 都道府県は、3,4,5桁目が0であるもの.
        return code.substring(2, 5) === "000";
    }

    /**
     * 指定されたコードが政令指定都市またはその行政区の自治体コードであるかどうかを返す
     */
    function _isOrdinanceDesignatedCityOrDistrict(code) {
        // 指定都市は、3桁目が1であるもの
        return code.substring(2, 3) === "1";
    }

    /**
     * 指定されたコードが政令指定都市の自治体コードであるかどうかを返す
     */
    function _isOrdinanceDesignatedCity(code) {
        // 指定都市は5桁目が0であるもの
        return _isOrdinanceDesignatedCityOrDistrict(code) && code.substring(4, 5) === "0";
    }

    /**
     * 指定されたコードが政令指定都市の行政区の自治体コードであるかどうかを返す
     */
    function _isAdministrativeDistrict(code) {
        return _isOrdinanceDesignatedCityOrDistrict(code) && !_isOrdinanceDesignatedCity(code);
    }

    return {
        isPrefecture: _isPrefecture,
        isOrdinanceDesignatedCityOrDistrict: _isOrdinanceDesignatedCityOrDistrict,
        isOrdinanceDesignatedCity: _isOrdinanceDesignatedCity,
        isAdministrativeDistrict: _isAdministrativeDistrict
    };
});

